import { createApp } from 'vue';
import App from './App.vue';
let indexApp = App;
// import AppV2 from './AppV2.vue';
// const PATHNAME = window.location.pathname;
// const VERSION = PATHNAME.slice(1, PATHNAME.length - 1);
// if (VERSION === 'v2') indexApp = AppV2;

createApp(indexApp)
  .mixin({
    methods: {
      formatNumber: function (value) {
        return new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(value);
      },
    },
  })
  // .use(router)
  .mount('#app');
